(function () {
  if (window.__ryCursor) return;
  window.__ryCursor = true;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || (window.Shopify && window.Shopify.designMode)) return;

  function start() {
    var hdr = document.querySelector('[data-ry-hdr]');
    if (hdr && hdr.getAttribute('data-cursor') === 'false') return;
    var root = document.documentElement;

    var css = [
      '.ry-cur-on,.ry-cur-on *{cursor:none!important}',
      '.ry-cur-on input,.ry-cur-on textarea,.ry-cur-on select,.ry-cur-on [contenteditable="true"]{cursor:auto!important}',
      '.ry-cur{position:fixed;left:0;top:0;z-index:2147483000;pointer-events:none;opacity:0;transition:opacity .35s ease}',
      '.ry-cur--blend{mix-blend-mode:difference;z-index:2147483001}',
      '.ry-cur.is-on{opacity:1}',
      '.ry-cur.is-off{opacity:0!important}',
      '.ry-cur__dot,.ry-cur__ring{position:fixed;left:0;top:0;border-radius:50%;will-change:transform}',
      '.ry-cur__dot{width:6px;height:6px;margin:-3px 0 0 -3px;background:#FFFFFF;transition:opacity .25s ease,width .3s ease,height .3s ease,margin .3s ease}',
      '.ry-cur__ring{width:36px;height:36px;margin:-18px 0 0 -18px;display:grid;place-items:center}',
      '.ry-cur__ring i{position:absolute;inset:0;border-radius:50%;box-shadow:inset 0 0 0 1px rgba(255,255,255,.9);transition:box-shadow .35s ease,opacity .35s ease}',
      '.ry-cur__ring b{position:absolute;inset:0;border-radius:50%;background:rgba(207,74,43,0);box-shadow:inset 0 0 0 1.5px rgba(238,122,85,0);transform:scale(.6);transition:background .35s ease,box-shadow .35s ease,transform .45s cubic-bezier(.2,.8,.2,1)}',
      '.ry-cur__lbl{position:relative;font:800 9px/1 Archivo,system-ui,sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#FFFFFF;opacity:0;transform:scale(.7);transition:opacity .25s ease,transform .35s cubic-bezier(.2,.8,.2,1);white-space:nowrap}',
      '.ry-cur.is-hot .ry-cur__dot{opacity:0}',
      '.ry-cur.is-hot .ry-cur__ring i{opacity:0}',
      '.ry-cur.is-hot .ry-cur__ring b{background:rgba(207,74,43,.14);box-shadow:inset 0 0 0 1.5px rgba(238,122,85,.95);transform:scale(1)}',
      '.ry-cur.is-label .ry-cur__ring b{background:rgba(196,67,31,.92);box-shadow:none;transform:scale(1)}',
      '.ry-cur.is-label .ry-cur__lbl{opacity:1;transform:none}',
      '.ry-cur.is-label .ry-cur__dot,.ry-cur.is-label .ry-cur__ring i{opacity:0}'
    ].join('\n');
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

    var blend = document.createElement('div'); blend.className = 'ry-cur ry-cur--blend'; blend.setAttribute('aria-hidden', 'true');
    blend.innerHTML = '<span class="ry-cur__ring"><i></i></span><span class="ry-cur__dot"></span>';
    var cur = document.createElement('div'); cur.className = 'ry-cur'; cur.setAttribute('aria-hidden', 'true');
    cur.innerHTML = '<span class="ry-cur__ring"><b></b><span class="ry-cur__lbl"></span></span>';
    document.body.appendChild(cur); document.body.appendChild(blend);
    root.classList.add('ry-cur-on');
    var ringA = blend.querySelector('.ry-cur__ring'), ringB = cur.querySelector('.ry-cur__ring'), dot = blend.querySelector('.ry-cur__dot'), lbl = cur.querySelector('.ry-cur__lbl');
    function cls(c, on) { cur.classList.toggle(c, on); blend.classList.toggle(c, on); }

    /* The header's data-cursor attribute is an on/off setting, not a cursor label, so it is excluded here */
    var HOT = 'a[href], button:not([disabled]), [role="tab"], [role="button"], summary, label[for], select, [data-cursor]:not([data-ry-hdr])';
    var TEXT = 'input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable="true"]';
    var HIDE = '[data-cursor-hide], [data-ra2-loupe], [data-rx-loupe], .rx__media[data-rx-loupe]';
    var MAG = '.ry-btn, .rt__btn, .ra__btn, .rk__cta, .ra2__lnk, .rx__lnk, .ry-pause, .ra2__pm, [data-cursor-magnet]';

    var mx = -100, my = -100, rx = -100, ry = -100, s = 1, sT = 1, p = 1, pT = 1, first = true;
    var target = null, magEl = null, label = '';

    function setState(el) {
      if (!el || !el.closest) return;
      var hide = el.closest(HIDE) || el.closest(TEXT);
      cls('is-off', !!hide);
      if (hide) { target = null; magEl = null; return; }
      var v = el.closest('video');
      var hot = el.closest(HOT);
      var lab = '';
      var hl = hot && hot.getAttribute('data-cursor');
      if (hl && hl !== 'true' && hl !== 'false') lab = hl;
      else if (!hot && v && v.closest('[data-cursor-video]')) lab = v.paused ? 'Play' : 'Pause';
      label = lab;
      lbl.textContent = lab;
      cls('is-label', !!lab);
      cls('is-hot', !!hot && !lab);
      sT = lab ? 2.1 : hot ? 1.55 : 1;
      target = hot;
      magEl = hot && !reduce ? hot.closest(MAG) : null;
    }

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (first) { rx = mx; ry = my; first = false; }
      cls('is-on', true);
    }, { passive: true });
    document.addEventListener('mouseover', function (e) { setState(e.target); });
    document.documentElement.addEventListener('mouseleave', function () { cls('is-on', false); });
    document.addEventListener('mousedown', function () { pT = 0.82; });
    document.addEventListener('mouseup', function () { pT = 1; });
    window.addEventListener('blur', function () { pT = 1; cls('is-on', false); });
    window.addEventListener('scroll', function () { if (target && !target.isConnected) setState(document.elementFromPoint(mx, my)); }, { passive: true });

    function frame() {
      var tx = mx, ty = my;
      if (magEl && magEl.isConnected) {
        var b = magEl.getBoundingClientRect();
        if (b.width && mx >= b.left - 12 && mx <= b.right + 12 && my >= b.top - 12 && my <= b.bottom + 12) {
          var cx = b.left + b.width / 2, cy = b.top + b.height / 2;
          tx = mx + (cx - mx) * 0.35; ty = my + (cy - my) * 0.35;
        }
      }
      var k = reduce ? 1 : 0.16;
      rx += (tx - rx) * k; ry += (ty - ry) * k;
      s += (sT - s) * (reduce ? 1 : 0.18);
      p += (pT - p) * 0.35;
      dot.style.transform = 'translate3d(' + mx.toFixed(1) + 'px,' + my.toFixed(1) + 'px,0)';
      var rt = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0) scale(' + (s * p).toFixed(3) + ')';
      ringA.style.transform = rt; ringB.style.transform = rt;
      lbl.style.transform = label ? 'scale(' + (1 / Math.max(1, s)).toFixed(3) + ')' : '';
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
